customElements.get('expotrade-product-tabs') || customElements.define('expotrade-product-tabs',
  class extends HTMLElement {
    constructor() {
      super()
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.tabFocus = 0;
      this.productRecommendationsSection = this.querySelector('.product-recommendations') || null;
      this.observer;
    }
    connectedCallback() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTabs);
      });

      this.addEventListener('keydown', (e) => {
        // Move right
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          tabs[this.tabFocus].setAttribute('tabindex', -1);
          if (e.key === 'ArrowRight') {
            this.tabFocus++;
            // If we're at the end, go to the start
            if (this.tabFocus >= tabs.length) {
              this.tabFocus = 0;
            }
            // Move left
          } else if (e.key === 'ArrowLeft') {
            this.tabFocus--;
            // If we're at the start, move to the end
            if (this.tabFocus < 0) {
              this.tabFocus = tabs.length - 1;
            }
          }

          tabs[this.tabFocus].setAttribute('tabindex', 0);
          tabs[this.tabFocus].focus();
        }
      });

      this.observer = new IntersectionObserver(this.handleIntersection, { rootMargin: '0px 0px 200px 0px' });

      this.observer.observe(this.productRecommendationsSection);

      if (this.productRecommendationsSection) {
        this.productRecommendationsSection.addEventListener('click', (e) => {
          if (e.target.classList.contains('recommendation__add-to-cart')) {
            this.addToCart(e.target.dataset.variantId, 1);
          }
        })
      }
    }

    changeTabs(e) {
      const target = e.target;
      const parent = target.parentNode.parentNode;
      const grandparent = parent.parentNode.parentNode;

      // Remove all current selected tabs
      parent.querySelectorAll('[aria-selected="true"]').forEach((t) => t.setAttribute('aria-selected', false));

      // Set this tab as selected
      target.setAttribute('aria-selected', true);

      // Hide all tab panels
      grandparent.querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute('hidden', true));

      // Show the selected panel
      grandparent.parentNode.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
    }

    handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this.productRecommendationsSection);

      const url = this.productRecommendationsSection.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    // function that adds variant to cart via Shopify ajax AP
    addToCart(variantId, quantity) {
      const data = {
        'id': variantId,
        'quantity': quantity
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data);
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
)
